module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"submit":"Next","return":"Previous"},"fr":{"submit":"Suivant","return":"Précédent"}}')
  delete Component.options._Ctor
}
